import offerPageStateReducer, { INITIAL_OFFER_PAGE_STATE, OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { EmptyArray } from 'lib/array/arrayUtils'
import { ReducerMiddleware } from 'lib/redux/reducerUtils'
import { Dispatch, useReducer } from 'react'

function useOfferPageReducer(
  defaultState: Partial<OfferPageState>,
  middlewares: Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = EmptyArray,
): [state: OfferPageState, dispatch: Dispatch<OfferPageDispatchAction>] {
  return useReducer(offerPageStateReducer(middlewares, true), { ...INITIAL_OFFER_PAGE_STATE, ...defaultState })
}

export default useOfferPageReducer
